(() => {
  const triggerSelector = '[data-rec-passport-trigger]';
  const dialogSelector = '[data-rec-passport-dialog]';
  let lastOpener = null;

  const visibleProductForm = () => {
    const forms = [...document.querySelectorAll('#MainContent form[action*="/cart/add"]')];
    return forms.find((form) => {
      const rect = form.getBoundingClientRect();
      const style = window.getComputedStyle(form);
      return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
    }) || forms[0];
  };

  const mountTrigger = () => {
    const trigger = document.querySelector(triggerSelector);
    if (!trigger) return;

    const standard = document.querySelector('[data-rec-product-experience]');
    if (standard && !standard.hidden && standard.parentNode) {
      if (trigger.nextElementSibling !== standard) standard.parentNode.insertBefore(trigger, standard);
    } else {
      const form = visibleProductForm();
      if (form && trigger.previousElementSibling !== form) form.insertAdjacentElement('afterend', trigger);
    }
    trigger.hidden = false;
  };

  const closeDialog = (dialog) => {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.hasAttribute('open')) dialog.close();
    else dialog.removeAttribute('open');
    document.documentElement.classList.remove('rec-passport-open');
  };

  const runFitCheck = (root) => {
    if (!root) return;
    const input = root.querySelector('[data-rec-fit-width]');
    const preference = root.querySelector('[data-rec-fit-preference]');
    const result = root.querySelector('[data-rec-fit-result]');
    if (!input || !preference || !result) return;

    const sizes = [
      { size: 'S', width: 18 },
      { size: 'M', width: 20 },
      { size: 'L', width: 22 },
      { size: 'XL', width: 24 },
      { size: '2XL', width: 26 },
      { size: '3XL', width: 28 },
      { size: '4XL', width: 30 }
    ];

    const update = () => {
      const measured = Number.parseFloat(input.value);
      if (!Number.isFinite(measured)) {
        result.textContent = 'Enter a laid-flat width above to run the fit check.';
        return;
      }
      if (measured < 14 || measured > 34) {
        result.innerHTML = '<strong>Double-check that measurement.</strong> Fit Check expects a laid-flat shirt width between 14 and 34 inches.';
        return;
      }

      const extraRoom = preference.value === 'roomy' ? 2 : 0;
      const target = measured + extraRoom;
      const match = sizes.find((item) => item.width >= target);

      if (!match) {
        result.innerHTML = '<strong>4XL is the largest size on the REC G640 chart.</strong> Your target fit is wider than 30″ laid flat, so ask REC before ordering instead of guessing.';
        return;
      }

      const fitText = preference.value === 'roomy' ? 'with one size-step of extra room built into the check' : 'for the closest same-or-larger chart match';
      result.innerHTML = `<strong>Closest REC chart match: ${match.size} — ${match.width}″ pit-to-pit.</strong> That recommendation is ${fitText}.`;
    };

    if (input.dataset.recFitBound !== 'true') {
      input.dataset.recFitBound = 'true';
      input.addEventListener('input', update);
      preference.addEventListener('change', update);
    }
  };

  const bindPassport = () => {
    const trigger = document.querySelector(triggerSelector);
    const dialog = document.querySelector(dialogSelector);
    if (!trigger || !dialog) return;

    const openButton = trigger.querySelector('[data-rec-passport-open]');
    if (openButton && openButton.dataset.recBound !== 'true') {
      openButton.dataset.recBound = 'true';
      openButton.addEventListener('click', () => {
        lastOpener = openButton;
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        document.documentElement.classList.add('rec-passport-open');
      });
    }

    dialog.querySelectorAll('[data-rec-passport-close]').forEach((button) => {
      if (button.dataset.recBound === 'true') return;
      button.dataset.recBound = 'true';
      button.addEventListener('click', () => closeDialog(dialog));
    });

    if (dialog.dataset.recBound !== 'true') {
      dialog.dataset.recBound = 'true';
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog(dialog);
      });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('rec-passport-open');
        if (lastOpener && document.contains(lastOpener)) lastOpener.focus({ preventScroll: true });
      });
      dialog.addEventListener('cancel', () => document.documentElement.classList.remove('rec-passport-open'));
    }

    const standardButton = dialog.querySelector('[data-rec-passport-standard]');
    if (standardButton && standardButton.dataset.recBound !== 'true') {
      standardButton.dataset.recBound = 'true';
      standardButton.addEventListener('click', () => {
        const standard = document.querySelector('[data-rec-product-experience]');
        closeDialog(dialog);
        if (!standard) return;
        window.setTimeout(() => {
          standard.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        }, 80);
      });
    }

    runFitCheck(dialog.querySelector('[data-rec-fit-finder]'));
  };

  const boot = () => {
    mountTrigger();
    bindPassport();
  };

  const start = () => {
    boot();
    window.setTimeout(boot, 900);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', boot);
})();